import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "../utils/api";

/**
 * Estado del onboarding Stripe Connect del host logueado.
 */
export function useStripeConnectStatus(token) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!token) {
      setStatus(null);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get(`${API}/stripe/connect/status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStatus(res.data);
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.detail || "Error consultando Stripe");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  return { status, loading, error, refresh: load };
}
